import React from 'react';
import { ArrowLeft } from 'lucide-react';

const SidebarHeader = ({ 
  showingArchived, 
  setShowingArchived
}) => {
  if (!showingArchived) return null;
  
  return (
    <div className="mb-4">
      <button
        onClick={() => setShowingArchived(false)}
        className="flex items-center text-sm theme-text-primary hover:theme-text-secondary transition-colors duration-200 p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 w-full"
      >
        <ArrowLeft size={16} className="mr-2" />
        Back to All Chats
      </button>
    </div>
  );
};

export default SidebarHeader;